import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import { jsx as ___EmotionJSX } from "@emotion/core";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import React, { useState } from 'react';
import LoginForm from './LoginForm';
import ForgotPasswordEmail from './login/ForgotPasswordEmail';
import ForgotPasswordCode from './login/ForgotPasswordCode';
import ResetPasswordForm from './login/ResetPasswordForm';
import ForgotPasswordHelp from './login/ForgotPasswordHelp';
import RegistrationForm from '../../registration/components/RegistrationForm';
import { css } from '@emotion/core';
import { AuthTransactionProvider } from './AuthTransactionProvider';
import { useAuth } from './useAuth';

var _ref = process.env.NODE_ENV === "production" ? {
  name: "43dg3c",
  styles: "padding-top:20px;button{text-transform:uppercase;}"
} : {
  name: "43dg3c",
  styles: "padding-top:20px;button{text-transform:uppercase;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

// Login business component
// TODO: Consider implementing the stepper part as a react context
var Login = function Login(_ref2) {
  var className = _ref2.className,
      _ref2$hasRememberMe = _ref2.hasRememberMe,
      hasRememberMe = _ref2$hasRememberMe === void 0 ? false : _ref2$hasRememberMe,
      _ref2$hasForgotPasswo = _ref2.hasForgotPassword,
      hasForgotPassword = _ref2$hasForgotPasswo === void 0 ? true : _ref2$hasForgotPasswo,
      _ref2$hasRegistration = _ref2.hasRegistration,
      hasRegistration = _ref2$hasRegistration === void 0 ? true : _ref2$hasRegistration,
      _ref2$loginAfterPassw = _ref2.loginAfterPasswordReset,
      loginAfterPasswordReset = _ref2$loginAfterPassw === void 0 ? true : _ref2$loginAfterPassw,
      _ref2$step = _ref2.step,
      step = _ref2$step === void 0 ? 1 : _ref2$step,
      getWithRedirect = _ref2.getWithRedirect,
      onLogin = _ref2.onLogin,
      onRegister = _ref2.onRegister,
      onRegisterLogin = _ref2.onRegisterLogin,
      onPasswordReset = _ref2.onPasswordReset,
      rest = _objectWithoutProperties(_ref2, ["className", "hasRememberMe", "hasForgotPassword", "hasRegistration", "loginAfterPasswordReset", "step", "getWithRedirect", "onLogin", "onRegister", "onRegisterLogin", "onPasswordReset"]);

  var _useAuth = useAuth(),
      authApi = _useAuth.authApi;

  var _useState = useState(step),
      _useState2 = _slicedToArray(_useState, 2),
      stepState = _useState2[0],
      setStepState = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      previousStep = _useState4[0],
      setPreviousStep = _useState4[1];

  var handlePasswordReset =
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(credentials) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!loginAfterPasswordReset) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return authApi.login(credentials);

            case 3:
              onPasswordReset && onPasswordReset(credentials);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handlePasswordReset(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var changeStep = function changeStep(value) {
    if (typeof value === 'number') {
      setPreviousStep(stepState);
      setStepState(value);
      return;
    }

    switch (value) {
      case 'prev':
        if (previousStep) {
          setStepState(previousStep);
          setPreviousStep(null);
          return;
        }

        setStepState(stepState - 1);
        break;

      default:
        setStepState(stepState + 1);
    }
  };

  var renderSwitch = function renderSwitch(step) {
    switch (step) {
      case 2:
        return ___EmotionJSX(ForgotPasswordEmail, {
          onStepChange: changeStep
        });

      case 3:
        return ___EmotionJSX(ForgotPasswordCode, {
          onStepChange: changeStep
        });

      case 4:
        return ___EmotionJSX(ResetPasswordForm, {
          onStepChange: changeStep,
          onPasswordReset: handlePasswordReset
        });

      case 5:
        return ___EmotionJSX(ForgotPasswordHelp, {
          onStepChange: changeStep
        });

      case 6:
        return ___EmotionJSX(RegistrationForm, {
          onStepChange: changeStep,
          onRegister: onRegister,
          onRegisterLogin: onRegisterLogin
        });

      default:
        return ___EmotionJSX(LoginForm, _extends({
          onLogin: onLogin,
          getWithRedirect: getWithRedirect,
          hasRememberMe: hasRememberMe,
          hasForgotPassword: hasForgotPassword,
          hasRegistration: hasRegistration,
          className: className,
          onStepChange: changeStep
        }, rest));
    }
  };

  return ___EmotionJSX("div", {
    className: className,
    css: _ref
  }, ___EmotionJSX(AuthTransactionProvider, null, renderSwitch(stepState)));
};

export default Login;